import { defaultApiState } from '@/store/types/general.types';
import { ModuleState } from './module.types';

export const moduleState: ModuleState = {
  apiState: {
    getModules: defaultApiState,
    getPaginatedModules: defaultApiState,
    createModule: defaultApiState,
    updateModule: defaultApiState
  },
  modules: undefined,
  paginatedModules: undefined
};
